import ReactDOM from 'react-dom';
import App from 'App';
import 'App.scss';
import 'tailwindcss/tailwind.css';

ReactDOM.render(<App />, document.getElementById('root'));
